import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { DetailsSection } from './components/DetailsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-[#FAF8F5] font-sans selection:bg-[#C4836A]/20 selection:text-[#C4836A]" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <DetailsSection data-id="element-4" />
      <PricingSection data-id="element-5" />
      <Footer data-id="element-6" />
    </main>;
}